import React from "react";
import "./singleModal.css";
import { Box, Grow, Modal } from "@mui/material";
import LongCard from "../../cards/longCard/LongCard";

const SingleModal = ({ data, openModal, handleClose }) => {
  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      sx={{ display: "flex", justifyContent: "center" }}
    >
      <Grow in={openModal}>
        <Box className="single-modal-body" marginX="auto">
          <LongCard
            key={data?._id}
            data={data}
            modifyData={data?.quantityData?.[0]}
            modify={true}
            handleClose={handleClose}
            setIcon={false}
          />
        </Box>
      </Grow>
    </Modal>
  );
};

export default SingleModal;
